import { useEffect, useState } from "react";
import axios from "axios";

const useNfuTiposMes = (year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
         
        
        const response = await axios.post(
          `https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerNfuTiposMes`,
          { 
            anio: year, 
            mes: mes, 
            provincia: provinciaSeleccionada || null,
            ciudad: ciudadSeleccionada || null,
            id_administrador: idAdministrador 
          },
          { headers: { Authorization: token } }
        );
        
                 
        if (response.data) {
           
          if (Array.isArray(response.data)) {
             
            setData(response.data);
          }
           
          else if (response.data.success && response.data.data) {
             
            setData(response.data.data);
          }
           
          else {
            console.warn("⚠️ Estructura de respuesta no reconocida:", response.data);
            setData([]);
          }
        }
        setError(null);
      } catch (error) {
         
        setError("Error al obtener datos de tipos por mes");
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    
    if (token && idAdministrador) {
      fetchData();
    } else {
       
      setLoading(false);
    }
  }, [year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada]);

  return { data, loading, error };
};

export default useNfuTiposMes;